import { Welcome } from '../components/Welcome/Welcome';
import { Footer } from '../components/Layout/Footer';

export function HomePage() {
  return (
    <>
      <Welcome />
      <Footer />
    </>
  );
}
